import { useEffect } from 'react';
import { isNative } from '../utils/platform';

export function useKeyboardScroll() {
  useEffect(() => {
    if (!isNative()) return;
    let cancelled = false;
    let removeListener = null;

    (async () => {
      const { Keyboard } = await import('@capacitor/keyboard');
      if (cancelled) return;

      const handle = await Keyboard.addListener('keyboardDidShow', () => {
        const el = document.activeElement;
        if (!el) return;
        const tag = el.tagName;
        const editable = tag === 'INPUT' || tag === 'TEXTAREA' || el.isContentEditable;
        if (!editable) return;
        el.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });

      removeListener = () => handle.remove();
    })();

    return () => {
      cancelled = true;
      if (removeListener) removeListener();
    };
  }, []);
}
